import { MutableRefObject, useLayoutEffect, useRef } from 'react';
import { useRachelPresentation } from '../../hooks/useRachelPresentation';

interface UseRachelInputRefocusParams {
  inputRef: MutableRefObject<HTMLInputElement | null>;
  portalNode: HTMLDivElement | null;
}

export const useRachelInputRefocus = ({ inputRef, portalNode }: UseRachelInputRefocusParams) => {
  const { isMaximized } = useRachelPresentation();
  const previousIsMaximizedRef = useRef(isMaximized);

  useLayoutEffect(() => {
    const hasToggledMaximize = previousIsMaximizedRef.current !== isMaximized;
    previousIsMaximizedRef.current = isMaximized;

    const input = inputRef.current;
    const isInsidePortal = !!input && !!portalNode?.contains(input);

    if (hasToggledMaximize || (isMaximized && isInsidePortal)) {
      input?.focus();
    }
  }, [isMaximized, portalNode, inputRef]);
};
